import { StackerPulpitPage } from "./StackerPulpitPage";

export const StackerPulpit = () => <StackerPulpitPage />;
